(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
/*
 * Announcement countdown.
 *
 * Two modes:
 *   rolling — a window that restarts each period, so an evergreen offer never
 *             shows an expired timer. The anchor is derived from the clock, not
 *             stored, so every visitor sees a consistent deadline.
 *   fixed   — counts to a specific date and then hides itself rather than
 *             sitting at zero, which reads as a broken promise.
 *
 * The deadline is computed client-side on purpose: Shopify caches pages, so a
 * server-rendered "14 hrs left" would be frozen at cache time.
 */
(function () {
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function deadlineFor(el) {
    var mode = el.getAttribute('data-mode') || 'daily';
    if (mode === 'fixed') {
      var raw = (el.getAttribute('data-ends') || '').trim().replace(' ', 'T');
      var t = Date.parse(raw);
      return isNaN(t) ? null : t;
    }
    // Rolling: next boundary of an N-hour window measured from midnight local.
    var hours = parseInt(el.getAttribute('data-hours'), 10);
    if (!hours || hours < 1) hours = 24;
    var now = new Date();
    var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    var windowMs = hours * 3600 * 1000;
    var elapsed = now.getTime() - midnight;
    return midnight + (Math.floor(elapsed / windowMs) + 1) * windowMs;
  }

  function start(el) {
    if (el.dataset.cdReady) return;
    el.dataset.cdReady = '1';

    var hrs = el.querySelector('[data-cd-hrs]');
    var min = el.querySelector('[data-cd-min]');
    var sec = el.querySelector('[data-cd-sec]');
    var live = el.querySelector('[data-cd-live]');
    if (!hrs || !min || !sec) return;

    var end = deadlineFor(el);
    if (end === null) { el.hidden = true; return; }

    var timer = null;
    var lastMinute = -1;

    function tick() {
      var left = end - Date.now();

      if (left <= 0) {
        if (el.getAttribute('data-mode') === 'fixed') {
          // Expired for good — remove it rather than show zeros.
          window.clearInterval(timer);
          el.hidden = true;
          return;
        }
        end = deadlineFor(el);   // rolling window rolls over
        left = end - Date.now();
      }

      var totalSec = Math.floor(left / 1000);
      hrs.textContent = pad(Math.floor(totalSec / 3600));
      min.textContent = pad(Math.floor(totalSec / 60) % 60);
      sec.textContent = pad(totalSec % 60);

      // Announce once a minute, not once a second, or screen readers never stop.
      var m = Math.floor(totalSec / 60);
      if (live && m !== lastMinute) {
        lastMinute = m;
        live.textContent = Math.floor(totalSec / 3600) + ' hours ' + (m % 60) + ' minutes remaining';
      }
    }

    tick();
    timer = window.setInterval(tick, 1000);
  }

  function init() { document.querySelectorAll('[data-countdown]').forEach(start); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-points"] && !Shopify.designMode) return;
  try {
    
/*
 * Reveals each point as the list scrolls into view. Fails open: if there is no
 * IntersectionObserver the items are shown immediately rather than left hidden.
 */
(function () {
  function init() {
    var items = document.querySelectorAll('[data-fp-item]:not([data-fp-ready])');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.setAttribute('data-fp-ready', '1');
        el.classList.add('is-revealed');
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        io.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -40px 0px' });

    items.forEach(function (el) {
      el.setAttribute('data-fp-ready', '1');
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
/*
 * Currency selector dropdown. The form itself is a normal Shopify localization
 * form, so choosing a country submits and reloads with the new market — this
 * only handles opening and closing the list.
 */
(function () {
  function init() {
    document.querySelectorAll('[data-localization]').forEach(function (root) {
      if (root.dataset.locReady) return;
      root.dataset.locReady = '1';

      var toggle = root.querySelector('[data-localization-toggle]');
      var list = root.querySelector('[data-localization-list]');
      if (!toggle || !list) return;

      function close() {
        list.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = list.hidden;
        list.hidden = !open;
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      document.addEventListener('click', function (e) {
        if (!root.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') close();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
/*
 * Load more.
 *
 * Fetches the next paginated page, lifts its grid items out of the response and
 * appends them, so filters, sort and scroll position all survive. Numbered
 * pagination stays in the markup and is only hidden once this script is running,
 * which keeps the page usable with JavaScript off.
 */
(function () {
  var wrap = document.querySelector('[data-load-more-wrap]');
  if (!wrap) return;

  var results = document.querySelector('.collection-results');
  var grid = document.querySelector('.collection-grid');
  var btn = wrap.querySelector('[data-load-more]');
  var bar = wrap.querySelector('[data-progress-bar]');
  var label = wrap.querySelector('[data-progress-label]');
  var progress = wrap.querySelector('[data-progress]');
  if (!grid || !btn) return;

  if (results) results.classList.add('js-load-more');

  var total = parseInt(wrap.getAttribute('data-total'), 10) || 0;
  var shown = parseInt(wrap.getAttribute('data-shown'), 10) || 0;
  var next = wrap.getAttribute('data-next-url') || '';

  function paint() {
    var pct = total ? Math.min(100, Math.round((shown / total) * 100)) : 0;
    if (bar) bar.style.width = pct + '%';
    if (progress) progress.setAttribute('aria-valuenow', shown);
    if (label) label.textContent = "You've viewed " + shown + ' of ' + total + ' products';
    if (!next) {
      btn.hidden = true;
      // Keep the progress line: "viewed 129 of 129" is a useful end state.
    }
  }

  btn.addEventListener('click', function () {
    if (!next || btn.disabled) return;
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Loading…';

    fetch(next)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var items = doc.querySelectorAll('.collection-grid__item');
        Array.prototype.forEach.call(items, function (li) {
          grid.appendChild(document.importNode(li, true));
        });
        shown += items.length;

        var nextLink = doc.querySelector('[data-load-more-wrap]');
        next = nextLink ? nextLink.getAttribute('data-next-url') || '' : '';

        btn.disabled = false;
        btn.textContent = original;
        paint();

        // New cards must obey any client-side facets already applied.
        document.dispatchEvent(new CustomEvent('collection:items-added'));
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });

  paint();
})();

/*
 * Collection copy: clamp with a Read more toggle, but only when the text is
 * actually taller than the clamp. Measuring first avoids offering to expand
 * three lines into three lines.
 */
(function () {
  var box = document.querySelector('[data-collection-copy]');
  if (!box) return;
  var body = box.querySelector('[data-copy-body]');
  var toggle = box.querySelector('[data-copy-toggle]');
  if (!body || !toggle) return;

  body.classList.add('is-clamped');
  if (body.scrollHeight <= body.clientHeight + 4) {
    body.classList.remove('is-clamped');
    toggle.hidden = true;
    return;
  }

  toggle.addEventListener('click', function () {
    var open = body.classList.toggle('is-clamped') === false;
    toggle.textContent = open ? 'Read less' : 'Read more';
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });
})();

/*
 * Client-side facets (Size / Colour / Fit).
 *
 * These exist because Shopify returns no filter for an option until it is added
 * in Search & Discovery. The markup is rendered only for facets the server is
 * NOT already providing, so this whole block goes quiet on its own once the
 * merchant configures them properly.
 *
 * Matching is on pipe-wrapped values ("|S|M|L|" tested for "|M|") so that "M"
 * cannot match "2XL"-style neighbours the way a bare indexOf would.
 *
 * Within one facet the values are OR'd (Black or Nude); across facets they are
 * AND'd (Black AND size M), which is what shoppers expect and what Shopify's own
 * filtering does.
 */
(function () {
  var root = document.querySelector('.collection-page');
  if (!root) return;

  var groups = root.querySelectorAll('[data-client-facet]');
  if (!groups.length) return;

  /*
   * Re-queried on every pass rather than cached: Load More appends cards after
   * this script runs, and a cached list would leave those new cards unfiltered
   * and visible regardless of what is ticked.
   */
  function allCards() {
    return Array.prototype.slice.call(root.querySelectorAll('[data-card]'));
  }
  var countEl = root.querySelector('[data-count-target]');
  var emptyEl = root.querySelector('.collection-empty');
  var countTemplate = countEl ? countEl.textContent.trim() : '';

  function selected(group) {
    return Array.prototype.slice
      .call(group.querySelectorAll('[data-client-value]'))
      .filter(function (i) { return i.checked; })
      .map(function (i) { return i.value; });
  }

  function matches(card, key, values) {
    if (!values.length) return true;
    var attr = card.getAttribute(
      key === 'colors' ? 'data-colors' : key === 'sizes' ? 'data-sizes' : 'data-fit'
    ) || '';
    // Fit is a single value; sizes/colours are pipe-delimited lists.
    if (key === 'fit') return values.indexOf(attr) !== -1;
    for (var i = 0; i < values.length; i++) {
      if (attr.indexOf('|' + values[i] + '|') !== -1) return true;
    }
    return false;
  }

  function apply() {
    var state = [];
    Array.prototype.forEach.call(groups, function (g) {
      var vals = selected(g);
      state.push({ key: g.getAttribute('data-client-facet'), values: vals });

      var badge = g.querySelector('[data-client-badge]');
      if (badge) {
        badge.textContent = vals.length;
        badge.hidden = vals.length === 0;
      }
    });

    var cards = allCards();
    var shown = 0;
    cards.forEach(function (card) {
      var ok = state.every(function (s) { return matches(card, s.key, s.values); });
      card.hidden = !ok;
      if (ok) shown++;
    });

    if (countEl && countTemplate) {
      // Reuse the server's phrasing, swapping only the number it already carries.
      countEl.textContent = countTemplate.replace(/\d+/, shown);
    }
    if (emptyEl) emptyEl.hidden = shown !== 0 || cards.length === 0;
  }

  // Load More appends cards; re-apply so they honour whatever is ticked.
  document.addEventListener('collection:items-added', apply);

  Array.prototype.forEach.call(groups, function (g) {
    g.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute('data-client-value')) apply();
    });
  });

  /*
   * Clear all is an <a> back to the collection URL, which handles the server
   * filters by reloading. When only client facets are set there is nothing to
   * reload for, so clear them in place instead and stay put.
   */
  var clear = root.querySelector('.collection-filters__clear');
  if (clear) {
    clear.addEventListener('click', function (e) {
      var anyClient = false;
      Array.prototype.forEach.call(groups, function (g) {
        if (selected(g).length) anyClient = true;
      });
      if (!anyClient) return;               // let the link do its normal job
      if (window.location.search.indexOf('filter.') !== -1) return;

      e.preventDefault();
      Array.prototype.forEach.call(groups, function (g) {
        Array.prototype.forEach.call(g.querySelectorAll('[data-client-value]'), function (i) {
          i.checked = false;
        });
      });
      apply();
    });
  }

  apply();
})();

/*
 * Filter drawer. The form submits normally, so everything here is enhancement:
 * open/close on mobile, auto-submit when sort changes, and a body scroll lock
 * while the drawer is open.
 */
(function () {
  function init() {
    document.querySelectorAll('[data-facet-form]').forEach(function (form) {
      if (form.dataset.facetReady) return;
      form.dataset.facetReady = '1';

      function setOpen(open) {
        form.classList.toggle('is-open', open);
        document.body.style.overflow = open ? 'hidden' : '';
      }

      var opener = document.querySelector('[data-facet-open]');
      if (opener) opener.addEventListener('click', function () { setOpen(true); });

      form.querySelectorAll('[data-facet-close]').forEach(function (el) {
        el.addEventListener('click', function () { setOpen(false); });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && form.classList.contains('is-open')) setOpen(false);
      });

      // Changing sort re-submits straight away — nobody expects to press Apply
      // for a sort order.
      var sort = form.querySelector('[data-facet-sort]');
      if (sort) sort.addEventListener('change', function () { form.submit(); });

      // On desktop the rail has no Apply button in view, so a ticked box should
      // just submit. Below 990px the shopper batches choices and taps Apply.
      form.addEventListener('change', function (e) {
        if (!e.target.matches || !e.target.matches('[data-facet-input]')) return;
        if (e.target.type === 'number') return;
        if (window.matchMedia('(min-width: 990px)').matches) form.submit();
      });

      // Empty number inputs would submit as blank params and litter the URL.
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var containers = document.querySelectorAll('.product-recommendations[data-url]');
    if (!containers.length) return;

    containers.forEach(function (container) {
      var url = container.getAttribute('data-url');
      if (!url || container.dataset.recommendationsFetched) return;
      container.dataset.recommendationsFetched = 'true';

      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.product-grid');
          var target = container.querySelector('.product-grid');
          if (newGrid && target && newGrid.children.length > 0) {
            target.innerHTML = newGrid.innerHTML;
            container.removeAttribute('hidden');
          }
        })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
/*
 * Review list: rating filter + progressive reveal.
 *
 * Both concerns run through one render pass rather than each toggling `hidden`
 * independently — that was the bug waiting to happen, since a filter and a
 * "show more" that both own visibility will contradict each other as soon as
 * they are used together.
 *
 * Every review is in the DOM from the server, so this only ever hides and shows;
 * nothing is fetched and the full list stays crawlable.
 */
(function () {
  function setup(root) {
    if (root.dataset.rvReady) return;
    root.dataset.rvReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-review]'));
    if (!items.length) return;

    var filters = root.querySelectorAll('[data-review-filter]');
    var moreWrap = root.querySelector('[data-reviews-more-wrap]');
    var moreBtn = root.querySelector('[data-reviews-more]');
    var status = root.querySelector('[data-reviews-status]');
    var statusText = root.querySelector('[data-reviews-status-text]');
    var clearBtn = root.querySelector('[data-reviews-clear]');
    var empty = root.querySelector('[data-reviews-empty]');

    var step = parseInt(root.getAttribute('data-initial'), 10) || 6;
    var limit = step;
    var active = null;   // null = every rating

    function matching() {
      return items.filter(function (el) {
        return active === null || el.getAttribute('data-rating') === active;
      });
    }

    function render() {
      var shown = 0;
      items.forEach(function (el) {
        var ok = active === null || el.getAttribute('data-rating') === active;
        if (ok && shown < limit) { el.hidden = false; shown++; }
        else { el.hidden = true; }
      });

      var total = matching().length;

      if (moreWrap) moreWrap.hidden = shown >= total;
      if (empty) empty.hidden = total !== 0;

      filters.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-review-filter') === active ? 'true' : 'false');
      });

      if (status) {
        status.hidden = active === null;
        if (statusText && active !== null) {
          statusText.textContent = 'Showing ' + total + ' ' + (total === 1 ? 'review' : 'reviews') +
            ' rated ' + active + ' star' + (active === '1' ? '' : 's');
        }
      }
    }

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-review-filter');
        // Clicking the active rating clears it, so the control toggles.
        active = (active === v) ? null : v;
        limit = step;
        render();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        active = null;
        limit = step;
        render();
      });
    }

    if (moreBtn) {
      moreBtn.addEventListener('click', function () {
        limit += step;
        render();
      });
    }

    render();
  }

  function init() { document.querySelectorAll('[data-reviews-root]').forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-submit"] && !Shopify.designMode) return;
  try {
    
/*
 * Progressive enhancement only — the star painting, the character counter and
 * pre-selecting the product from the URL. The form posts natively to Shopify
 * with or without any of this.
 */
(function () {
  function setup(form) {
    if (form.dataset.rvfReady) return;
    form.dataset.rvfReady = '1';

    var stars = form.querySelectorAll('[data-rvf-stars] .rvf__star');
    var body = form.querySelector('#rvf-body');
    var count = form.querySelector('[data-rvf-count]');
    var productSel = form.querySelector('[data-rvf-product]');
    var sourceEl = form.querySelector('[data-rvf-source]');

    /* ─── Pre-selection from ?product= and ?src= ─────────────────────────── */
    var params = new URLSearchParams(window.location.search);
    var wanted = params.get('product');
    if (wanted && productSel) {
      /*
       * The option values are product titles, because the title is what is
       * useful in the notification email. The QR codes carry handles, so match
       * on a slugified title rather than on the value directly.
       */
      var slug = function (str) {
        return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
      };
      var target = slug(wanted);
      var match = Array.prototype.slice.call(productSel.options).filter(function (o) {
        return o.value && (slug(o.value) === target || target.indexOf(slug(o.value)) === 0);
      })[0];
      if (match) {
        productSel.value = match.value;
        var field = productSel.closest('.rvf__field');
        if (field) field.hidden = true;
      }
    }
    if (sourceEl && params.get('src')) sourceEl.value = params.get('src').slice(0, 40);

    /* ─── Stars ──────────────────────────────────────────────────────────── */
    function paint(upTo) {
      stars.forEach(function (star) {
        star.classList.toggle('is-on', parseInt(star.getAttribute('data-value'), 10) <= upTo);
      });
    }
    function chosen() {
      var checked = form.querySelector('input[name="contact[Rating]"]:checked');
      return checked ? parseInt(checked.value, 10) : 0;
    }
    stars.forEach(function (star) {
      var v = parseInt(star.getAttribute('data-value'), 10);
      star.addEventListener('mouseenter', function () { paint(v); });
      star.addEventListener('click', function () { paint(v); });
      var input = star.querySelector('input');
      input.addEventListener('change', function () { paint(v); });
      input.addEventListener('focus', function () { paint(v); });
    });
    var group = form.querySelector('[data-rvf-stars]');
    if (group) group.addEventListener('mouseleave', function () { paint(chosen()); });

    /* ─── Character count ────────────────────────────────────────────────── */
    if (body && count) {
      var update = function () { count.textContent = body.value.length + ' / 2000'; };
      body.addEventListener('input', update);
      update();
    }

    paint(chosen());
  }

  function init() { document.querySelectorAll('[data-review-form]').forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-to-top"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-scroll-to-top]');
  if (!button) return;
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart-shorts"] && !Shopify.designMode) return;
  try {
    
(function () {
  var IN_PER_CM = 0.393701;
  var LB_PER_KG = 2.20462;

  // "150-160" / "80-100" / "175-200" -> [150, 160]. Also copes with a bare number.
  function parseRange(raw) {
    var nums = String(raw).match(/\d+(?:\.\d+)?/g);
    if (!nums || !nums.length) return null;
    var lo = parseFloat(nums[0]);
    var hi = nums.length > 1 ? parseFloat(nums[1]) : lo;
    return [Math.min(lo, hi), Math.max(lo, hi)];
  }

  // Always resolve to a row/column: exact hit if the value sits inside a range,
  // otherwise the closest one. `off` carries how far outside the chart it fell so
  // the UI can add a caveat instead of silently pretending it was a clean match.
  function pickIndex(ranges, value) {
    var exact = -1, nearest = -1, best = Infinity;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (!r) continue;
      if (value >= r[0] && value <= r[1]) { exact = i; break; }
      var dist = value < r[0] ? r[0] - value : value - r[1];
      if (dist < best) { best = dist; nearest = i; }
    }
    if (exact !== -1) return { index: exact, off: 0 };
    if (nearest !== -1) return { index: nearest, off: best };
    return null;
  }

  function parseMatrix(text) {
    var rows = String(text).split(/\r?\n/).map(function (r) { return r.trim(); }).filter(Boolean);
    if (rows.length < 2) return null;
    return {
      columns: rows[0].split(',').slice(1).map(function (c) { return c.trim(); }),
      rows: rows.slice(1).map(function (r) {
        return r.split(',').map(function (c) { return c.trim(); });
      }),
    };
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function unitLabel(unit) { return unit === 'lb' ? 'lbs' : unit; }

  // Charts and product options often spell the same size differently (XXL vs
  // 2XL), so compare a normalised form rather than the raw string.
  function normalizeSize(v) {
    var t = String(v).toUpperCase().replace(/[\s\-_.]/g, '');
    var m = t.match(/^([2-9])XL$/);
    if (m) return m[1] + 'XL';
    var xs = t.match(/^(X{2,})L$/);              // XXL -> 2XL, XXXL -> 3XL
    if (xs) return xs[1].length + 'XL';
    return t;
  }

  // Where the recommended size can be selected: a variant radio, or a bundle
  // picker's size button.
  function findSizeControl(size) {
    var wanted = normalizeSize(size), found = null;
    document.querySelectorAll('.variant-pill__input, [data-option-input]').forEach(function (input) {
      if (found || !input.value || input.disabled) return;
      if (normalizeSize(input.value) === wanted) found = { type: 'input', el: input };
    });
    if (found) return found;
    document.querySelectorAll('[data-bp-size]').forEach(function (btn) {
      if (found) return;
      if (normalizeSize(btn.getAttribute('data-bp-size')) === wanted) found = { type: 'button', el: btn };
    });
    return found;
  }

  function init(root) {
    var dataEl = document.querySelector('[data-fit-finder-data]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var matrix = parseMatrix(cfg.matrix || '');
    if (!matrix) return;

    var strings = cfg.strings || {};
    // The units the merchant typed the chart in. Everything is converted into
    // these before any lookup happens.
    var chartUnits = {
      height: (cfg.heightUnit || 'cm').toLowerCase(),
      weight: (cfg.weightUnit || 'lb').toLowerCase(),
    };

    var columnRanges = matrix.columns.map(parseRange);
    var rowRanges = matrix.rows.map(function (r) { return parseRange(r[0]); });

    var heightInput = root.querySelector('[data-height]');
    var weightInput = root.querySelector('[data-weight]');
    var resultEl = root.querySelector('[data-result]');
    if (!heightInput || !weightInput || !resultEl) return;

    // Inputs start in the chart's own units, so nothing is converted until the
    // customer switches.
    var units = { height: chartUnits.height, weight: chartUnits.weight };

    function paintUnits(group) {
      root.querySelectorAll('[data-unit-group="' + group + '"]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-unit') === units[group]);
      });
      root.querySelectorAll('[data-unit-tag="' + group + '"]').forEach(function (tag) {
        tag.textContent = unitLabel(units[group]);
      });
    }
    paintUnits('height');
    paintUnits('weight');

    root.querySelectorAll('[data-unit-group]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-unit-group');
        units[group] = btn.getAttribute('data-unit');
        paintUnits(group);
        resultEl.hidden = true;
      });
    });

    function show(html, isError) {
      resultEl.innerHTML = '<div class="fit-finder__card' + (isError ? ' fit-finder__card--error' : '') + '">' + html + '</div>';
      resultEl.hidden = false;
    }

    function toChartUnits(value, group) {
      var from = units[group], to = chartUnits[group];
      if (from === to) return value;
      if (group === 'height') return from === 'in' ? value / IN_PER_CM : value * IN_PER_CM;
      return from === 'kg' ? value * LB_PER_KG : value / LB_PER_KG;
    }

    function calculate() {
      var height = parseFloat(heightInput.value);
      var weight = parseFloat(weightInput.value);

      if (!isFinite(height) || !isFinite(weight) || height <= 0 || weight <= 0) {
        show('<p class="fit-finder__answer">' + escapeHtml(strings.incomplete || 'Enter your height and weight.') + '</p>', true);
        return;
      }

      var row = pickIndex(rowRanges, toChartUnits(height, 'height'));
      var col = pickIndex(columnRanges, toChartUnits(weight, 'weight'));
      var cell = row && col ? matrix.rows[row.index][col.index + 1] : null;
      var size = cell && cell !== '/' ? cell : null;

      if (!size) {
        show('<p class="fit-finder__answer">' + escapeHtml(strings.none || 'We could not match those measurements.') + '</p>', true);
        return;
      }

      var detail = (strings.detail || 'Based on {height} tall and {weight}.')
        .replace('{height}', matrix.rows[row.index][0] + ' ' + chartUnits.height)
        .replace('{weight}', matrix.columns[col.index] + ' ' + unitLabel(chartUnits.weight));

      var html = '<p class="fit-finder__answer">' + escapeHtml(strings.recommend || 'We recommend size') + '</p>' +
                 '<p class="fit-finder__size">' + escapeHtml(size) + '</p>' +
                 '<p class="fit-finder__detail">' + escapeHtml(detail) + '</p>';

      // Be explicit when the measurements fell outside the chart, rather than
      // presenting the nearest row as a clean match.
      if (row.off > 0 || col.off > 0) {
        html += '<p class="fit-finder__detail fit-finder__caveat">' +
                escapeHtml(strings.approx || 'Your measurements sit outside our listed range, so this is the closest fit.') +
                '</p>';
      }

      var control = findSizeControl(size);
      if (control) {
        html += '<button type="button" class="btn btn--primary fit-finder__apply" data-apply>' +
                escapeHtml(strings.apply || 'Select this size') + '</button>';
      }

      show(html, false);

      var applyBtn = resultEl.querySelector('[data-apply]');
      if (applyBtn && control) {
        applyBtn.addEventListener('click', function () {
          if (control.type === 'input') {
            control.el.checked = true;
            control.el.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            control.el.click();
          }
          var closer = document.querySelector('[data-size-chart-close]');
          if (closer) closer.click();
        });
      }
    }

    root.querySelectorAll('[data-find]').forEach(function (b) {
      b.addEventListener('click', calculate);
    });
    [heightInput, weightInput].forEach(function (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); calculate(); }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-fit-finder]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-chart"] && !Shopify.designMode) return;
  try {
    
(function () {
  var IN_PER_CM = 0.393701;

  // "27\"-29\"" / "3.5\"-4.5\"" / "27-29" -> [27, 29]. Also copes with a bare number.
  function parseRange(raw) {
    var nums = String(raw).match(/\d+(?:\.\d+)?/g);
    if (!nums || !nums.length) return null;
    var lo = parseFloat(nums[0]);
    var hi = nums.length > 1 ? parseFloat(nums[1]) : lo;
    return [Math.min(lo, hi), Math.max(lo, hi)];
  }

  function firstNumber(raw) {
    var m = String(raw).match(/\d+(?:\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }

  // Always resolve to a row/column: exact hit if the value sits inside a range,
  // otherwise the closest one. `off` carries how far outside the table it fell so
  // the UI can add a caveat instead of silently pretending it was a clean match.
  function pickIndex(ranges, value) {
    var exact = -1, nearest = -1, best = Infinity;
    for (var i = 0; i < ranges.length; i++) {
      var r = ranges[i];
      if (!r) continue;
      if (value >= r[0] && value <= r[1]) { exact = i; break; }
      var dist = value < r[0] ? r[0] - value : value - r[1];
      if (dist < best) { best = dist; nearest = i; }
    }
    if (exact !== -1) return { index: exact, off: 0 };
    if (nearest !== -1) return { index: nearest, off: best };
    return null;
  }

  function parseMatrix(text) {
    var rows = String(text).split(/\r?\n/).map(function (r) { return r.trim(); }).filter(Boolean);
    if (!rows.length) return null;
    var header = rows[0].split(',').map(function (c) { return c.trim(); });
    var body = rows.slice(1).map(function (r) {
      return r.split(',').map(function (c) { return c.trim(); });
    });
    return { bands: header.slice(1), rows: body };
  }

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function init(root) {
    var dataEl = document.querySelector('[data-size-finder-data]');
    if (!dataEl) return;
    var cfg;
    try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var strings = cfg.strings || {};
    var bandRanges = (cfg.bandRanges || []).map(parseRange);
    var bandSizes = (cfg.bandSizes || []).map(function (b) { return String(b).trim(); });
    var cupLetters = (cfg.cupLetters || []).map(function (c) { return String(c).trim(); });
    var cupRanges = (cfg.cupRanges || []).map(parseRange);
    var matrix = parseMatrix(cfg.matrix || '');

    var underInput = root.querySelector('[data-under]');
    var overInput = root.querySelector('[data-over]');
    var resultEl = root.querySelector('[data-result]');
    var unitBtns = root.querySelectorAll('[data-unit]');
    var unitTags = root.querySelectorAll('[data-unit-tag]');
    var unit = 'in';

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        unit = btn.getAttribute('data-unit');
        unitBtns.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        unitTags.forEach(function (t) { t.textContent = unit; });
        resultEl.hidden = true;
      });
    });

    function show(html, isError) {
      resultEl.innerHTML = '<div class="size-finder__card' + (isError ? ' size-finder__card--error' : '') + '">' + html + '</div>';
      resultEl.hidden = false;
    }

    function toInches(v) { return unit === 'cm' ? v * IN_PER_CM : v; }

    function calculate() {
      var under = parseFloat(underInput.value);
      var over = parseFloat(overInput.value);

      if (!isFinite(under) || !isFinite(over) || under <= 0 || over <= 0) {
        show('<p class="size-finder__answer">' + escapeHtml(strings.incomplete || 'Enter both measurements.') + '</p>', true);
        return;
      }

      under = toInches(under);
      over = toInches(over);

      if (over < under) {
        show('<p class="size-finder__answer">' + escapeHtml(strings.invalid || 'Your bust measurement should be larger than your under-bust.') + '</p>', true);
        return;
      }

      var band = pickIndex(bandRanges, under);
      if (!band) {
        show('<p class="size-finder__answer">' + escapeHtml(strings.none || 'We could not match that measurement.') + '</p>', true);
        return;
      }
      var bandLabel = bandSizes[band.index] || '';
      var bandNumber = firstNumber(bandLabel);

      var diff = over - (bandNumber !== null ? bandNumber : under);
      var cup = pickIndex(cupRanges, diff);
      if (!cup) {
        show('<p class="size-finder__answer">' + escapeHtml(strings.none || 'We could not match that measurement.') + '</p>', true);
        return;
      }
      var cupLabel = cupLetters[cup.index] || '';

      // Look the size up in the merchant's matrix. Some band/cup combinations are
      // marked "/" (not made in this style) — rather than dead-ending, walk the
      // same band column to the nearest cup that does exist.
      var size = null, substituted = false;
      if (matrix) {
        var col = -1;
        for (var i = 0; i < matrix.bands.length; i++) {
          if (firstNumber(matrix.bands[i]) === bandNumber) { col = i; break; }
        }
        var rowIndex = -1;
        for (var r = 0; r < matrix.rows.length; r++) {
          if (matrix.rows[r][0] === cupLabel) { rowIndex = r; break; }
        }
        function cellAt(ri) {
          if (col === -1 || ri < 0 || ri >= matrix.rows.length) return null;
          var v = matrix.rows[ri][col + 1];
          return v && v !== '/' ? v : null;
        }
        if (rowIndex !== -1) {
          size = cellAt(rowIndex);
          for (var step = 1; !size && step < matrix.rows.length; step++) {
            size = cellAt(rowIndex - step) || cellAt(rowIndex + step);
            if (size) substituted = true;
          }
        }
      }

      if (!size) {
        show('<p class="size-finder__answer">' + escapeHtml(strings.none || 'We could not match that combination.') + '</p>', true);
        return;
      }

      var detail = (strings.because || 'Band {band}, cup {cup} — a {difference}\" difference.')
        .replace('{band}', bandLabel)
        .replace('{cup}', cupLabel)
        .replace('{difference}', (Math.round(diff * 10) / 10));

      var html = '<p class="size-finder__answer">' + escapeHtml(strings.recommend || 'We recommend') + '</p>' +
                 '<p class="size-finder__size">' + escapeHtml(size) + '</p>' +
                 '<p class="size-finder__detail">' + escapeHtml(detail) + '</p>';

      // Be explicit when we had to approximate, rather than implying a clean match.
      var offBy = Math.max(band.off, cup.off);
      if (offBy > 0.5 || substituted) {
        html += '<p class="size-finder__detail size-finder__caveat">' +
                escapeHtml(strings.approx || 'Your measurements sit between our listed sizes, so this is the closest fit. Get in touch if it does not feel right.') +
                '</p>';
      }

      // Offer to select that size on the product form. Size charts and product
      // options often spell the same size differently (XXL vs 2XL), so compare a
      // normalised form rather than the raw string.
      function normalizeSize(v) {
        var t = String(v).toUpperCase().replace(/[\s\-_.]/g, '');
        var m = t.match(/^([2-9])X L?$/) || t.match(/^([2-9])XL$/);
        if (m) return m[1] + 'XL';
        var xs = t.match(/^(X{2,})L$/);              // XXL -> 2XL, XXXL -> 3XL
        if (xs) return xs[1].length + 'XL';
        return t;
      }

      var target = null, wantedNorm = normalizeSize(size);
      document.querySelectorAll('.variant-pill__input, [data-option-input]').forEach(function (input) {
        if (target || !input.value) return;
        if (normalizeSize(input.value) === wantedNorm && !input.disabled) target = input;
      });
      if (target) {
        html += '<button type="button" class="btn btn--primary size-finder__apply" data-apply>' +
                escapeHtml(strings.apply || 'Select this size') + '</button>';
      }

      show(html, false);

      var applyBtn = resultEl.querySelector('[data-apply]');
      if (applyBtn && target) {
        applyBtn.addEventListener('click', function () {
          target.checked = true;
          target.dispatchEvent(new Event('change', { bubbles: true }));
          var closer = document.querySelector('[data-size-chart-close]');
          if (closer) closer.click();
        });
      }
    }

    root.querySelectorAll('[data-find]').forEach(function (b) {
      b.addEventListener('click', calculate);
    });
    [underInput, overInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); calculate(); } });
    });
  }

  function boot() {
    document.querySelectorAll('[data-size-finder]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
/*
 * Testimonial carousel arrows.
 *
 * Scrolls the native overflow container rather than transforming a track, so
 * touch swiping, scroll snapping and keyboard scrolling all keep working for
 * free — the buttons are only a pointer affordance on top of that.
 */
(function () {
  function setup(root) {
    if (root.dataset.testiReady) return;
    root.dataset.testiReady = '1';

    var track = root.querySelector('[data-testi-track]');
    var prev = root.querySelector('[data-testi-prev]');
    var next = root.querySelector('[data-testi-next]');
    if (!track || !prev || !next) return;

    function step() {
      var card = track.querySelector('.testimonials__card');
      if (!card) return track.clientWidth;
      // One card plus the gap, so a click lands cleanly on the next snap point.
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      /*
       * Tolerance is derived from the track's own padding, not a fixed 2px.
       * The row carries 4px of padding so the focus ring is not clipped, and
       * scroll-snap rests scrollLeft at 4 rather than 0 — which read as
       * "already scrolled" and left the prev arrow showing at the start.
       */
      var pad = parseFloat(window.getComputedStyle(track).paddingLeft) || 0;
      var slack = pad + 2;
      prev.hidden = track.scrollLeft <= slack;
      next.hidden = track.scrollLeft >= max - slack;
      // Nothing to scroll at all — hide both rather than leave dead controls.
      if (max <= slack) { prev.hidden = true; next.hidden = true; }
    }

    prev.addEventListener('click', function () { track.scrollLeft -= step(); });
    next.addEventListener('click', function () { track.scrollLeft += step(); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    sync();
    /*
     * Re-sync once layout has settled. On first paint the card widths are not
     * final, so scrollWidth can read short and both arrows resolve wrong — the
     * prev arrow was showing while the row sat at position zero.
     */
    window.requestAnimationFrame(sync);
    window.addEventListener('load', sync);
    window.setTimeout(sync, 400);
  }

  function init() { document.querySelectorAll('[data-testi-carousel]').forEach(setup); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function toEmbed(url) {
    var yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{6,})/);
    if (yt) return 'https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0&playsinline=1';
    var vm = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (vm) return 'https://player.vimeo.com/video/' + vm[1] + '?autoplay=1';
    return null;
  }

  function stars(value) {
    var v = parseFloat(value);
    if (!isFinite(v)) return '';
    var full = Math.floor(v), half = v - full >= 0.5 ? 1 : 0;
    return '★'.repeat(full) + (half ? '☆' : '') + '☆'.repeat(Math.max(0, 5 - full - half));
  }

  function init(root) {
    if (root.dataset.vtReady) return;
    root.dataset.vtReady = '1';

    var box = root.querySelector('[data-vt-lightbox]');
    if (!box) return;
    var stage = box.querySelector('[data-vt-lightbox-stage]');
    var info = box.querySelector('[data-vt-lightbox-info]');
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-vt-play]'));
    var index = -1;
    var lastFocus = null;

    function clearStage() {
      stage.innerHTML = '';
    }

    function show(i) {
      if (i < 0 || i >= buttons.length) return;
      index = i;
      var btn = buttons[i];
      clearStage();

      // Move the clicked card's video into the dialog. Only this one ever loads.
      var blockId = btn.getAttribute('data-vt-block');
      var tpl = blockId ? root.querySelector('[data-vt-source="' + blockId + '"]') : null;
      var external = btn.getAttribute('data-vt-external');

      if (tpl) {
        stage.insertAdjacentHTML('beforeend', tpl.innerHTML);
        var video = stage.querySelector('video');
        if (video) {
          video.setAttribute('playsinline', '');
          video.controls = true;
          var p = video.play();
          if (p && p.catch) p.catch(function () {});
        }
      } else if (external) {
        var src = toEmbed(external);
        if (src) {
          var iframe = document.createElement('iframe');
          iframe.src = src;
          iframe.allow = 'autoplay; fullscreen; picture-in-picture';
          iframe.setAttribute('allowfullscreen', '');
          stage.appendChild(iframe);
        }
      }

      // Shoppable panel
      var title = btn.getAttribute('data-vt-title') || '';
      var url = btn.getAttribute('data-vt-url') || '';
      var rating = btn.getAttribute('data-vt-rating') || '';
      var eyebrow = btn.getAttribute('data-vt-eyebrow') || '';
      var cta = btn.getAttribute('data-vt-cta') || 'Shop now';

      box.querySelector('[data-vt-lb-eyebrow]').textContent = eyebrow;
      box.querySelector('[data-vt-lb-title]').textContent = title;

      var ratingWrap = box.querySelector('[data-vt-lb-rating]');
      if (rating) {
        box.querySelector('[data-vt-lb-stars]').textContent = stars(rating);
        box.querySelector('[data-vt-lb-rating-value]').textContent = rating;
        ratingWrap.hidden = false;
      } else {
        ratingWrap.hidden = true;
      }

      var link = box.querySelector('[data-vt-lb-cta]');
      if (url) { link.href = url; link.textContent = cta; link.hidden = false; }
      else { link.hidden = true; }

      info.hidden = !(title || url);

      var prev = box.querySelector('[data-vt-prev]');
      var next = box.querySelector('[data-vt-next]');
      if (prev) prev.hidden = buttons.length < 2;
      if (next) next.hidden = buttons.length < 2;
    }

    function open(i) {
      lastFocus = document.activeElement;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      show(i);
      var close = box.querySelector('[data-vt-lightbox-close]');
      if (close && close.focus) close.focus();
    }

    function close() {
      clearStage();
      box.hidden = true;
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () { open(i); });
    });

    box.querySelectorAll('[data-vt-lightbox-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });
    var prevBtn = box.querySelector('[data-vt-prev]');
    var nextBtn = box.querySelector('[data-vt-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { show((index - 1 + buttons.length) % buttons.length); });
    if (nextBtn) nextBtn.addEventListener('click', function () { show((index + 1) % buttons.length); });

    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight' && nextBtn) nextBtn.click();
      if (e.key === 'ArrowLeft' && prevBtn) prevBtn.click();
    });
  }

  function boot() { document.querySelectorAll('.video-testimonials').forEach(function (el) {
    init(el.closest('.shopify-section') || el);
  }); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
